import * as React from 'react';
import { Opgave } from '../../models/Opgave';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import RichTextEditor from '../../uiComponents/input/RichTextEditor';
import DraftHelper from '../../infrastructure/DraftHelper';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { LinkSecondaryButton } from '../../uiComponents/input/Buttons';
import { Clearfix } from '../../uiComponents/layout/Clearfix';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';

interface KonkurrenceOpgaveOftestStilledeSpoergsmaalProps {
    opgave: Opgave;
}

class KonkurrenceOpgaveOftestStilledeSpoergsmaal extends React.Component<KonkurrenceOpgaveOftestStilledeSpoergsmaalProps,
    any> {

    constructor(props: KonkurrenceOpgaveOftestStilledeSpoergsmaalProps) {
        super(props);
        this.getSpoergsmaalButtons = this.getSpoergsmaalButtons.bind(this);
    }

    getEditorState() {
        return DraftHelper.getContentAsEditorState(this.props.opgave.oftestStilledeSpoergsmaalIndhold);
    }

    getSpoergsmaalLink() {
        return '/stilspoergsmaal/' + this.props.opgave.id;
    }

    getSpoergsmaalButtons() {
        var bruger = getLoggedInBruger();

        if (bruger.rolle === BrugerRolleEnum.Laerer) {
            return (
                <ButtonSection>
                    <p className='oftest-stillede-spoergsmaal-kontakt-text'>Har du spørgsmål, som ikke bliver besvaret herover, så kontakt os.</p>
                    <LinkSecondaryButton
                        url={this.getSpoergsmaalLink()}
                        text='Send os dit spørgsmål'
                    />
                </ButtonSection>
            );
        }

        return undefined;
    }

    render() {
        return (
            <div className='oftest-stillede-spoergsmaal-visning'>
                <ContentWrapper>
                    <SectionGroup header='Svar fra oftest stillede spørgsmål'>
                        <Section className='oftest-stillede-spoergsmaal-content' fullWidth={true}>
                            <Col md={9} mdOffset={3}>
                                <RichTextEditor readOnly={true} editorState={this.getEditorState()} />
                            </Col>
                            <Clearfix />
                        </Section>
                        {this.getSpoergsmaalButtons()}
                    </SectionGroup>
                </ContentWrapper>
            </div>
        );
    }
}

export default KonkurrenceOpgaveOftestStilledeSpoergsmaal;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceOpgaveOftestStilledeSpoergsmaal.tsx